<template>
  <div class="home">
    <div class="home-shuffling">
      <img class="home-img" src="../../assets/news-information.jpg">
    </div>
    <div class="home-nav">
        <div>
            <div class="news-list-box" @click="$router.push(`/newsDetails/${item.id}`)" v-for="(item,index) in newsData" :key="index">
                <img class="news-list-img" :src="'https://branew-pic.oss-cn-beijing.aliyuncs.com/' + item.images" alt="">
                <div class="news-list-nav">
                    <div class="news-title"> {{item.title}}</div>
                    <div class="news-nav">{{item.brief}}</div>
                    <div class="news-time">{{item.timePublish | formatterDate}}</div>
                </div>
            </div>
        </div>
      <el-pagination background
                     layout="prev, pager, next"
                     :page-size="pageSize"
                     :page-sizes="[5, 10, 20, 25]"
                     :total="itemTotal"
                     @current-change="changePage"
                     @size-change="handleSizeChange">
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'
import bus from '@/components/bus';
import dayjs from 'dayjs'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },

  data(){
    return {
        pageSize: 5,
        dynQuery:{
            size: 5,
            from: 0,
        },
        currentPage: 1,
        itemTotal: 0,

        newsData: [],
    }
  },
    created(){
        this.fetchBillDetail();
    },
  mounted(){
      bus.$emit('changeRoute', this.$route.path);
  },
  filters: {
    formatterDate: function (cellValue) {
      if (!cellValue) {
            return '';
        }
        return dayjs(Number(cellValue)).format('YYYY-MM-DD');
    }
  },
  methods: {
      handleSizeChange(val) {
          this.pageSize = val;
          this.dynQuery.size = val;
          this.changePage(this.currentPage);
      },
      // 当前页发生变化
      changePage(currentPage) {
          this.dynQuery.from = this.pageSize * (currentPage - 1);
          this.fetchBillDetail();
      },
      fetchBillDetail(){
        //   this.$fetch("store/select/contentArticle",{from: this.dynQuery.from, size: this.dynQuery.size, id: 30}).then(res => {
        //     console.log('store/select/contentArticle',res);
        //     this.newsData = res.items;
        //     this.itemTotal = res.total;
        // })

        this.$fetch("store/select/contentColumn").then(result => {
          result.map(item => {
            if(item.name == "新闻资讯"){
              this.$fetch("store/select/contentArticle",{from: this.dynQuery.from, size: this.dynQuery.size, id: item.id}).then(res => {
                  console.log('store/select/contentArticle',res);
                  this.newsData = res.items;
                  this.itemTotal = res.total;
              })
            }
          })
        })
      },
  }
  
}
</script>
<style scoped lang="scss">
.home{
    width: 100%;
    background: #F3F5FA;
    overflow: hidden;
    margin-top: -91px;
}
.home-img{
  width: 100%;
  height: 28.5rem;
}
.home-nav{
  padding: 2rem 12rem;

    .news-list-box{
        background: #fff;
        display: flex;
        margin: 1rem 0;
        color: #666;
        text-align: left;
    }
    .news-list-img{
        width: 50%;
        height: 11rem;
    }
    .news-list-nav{
        width: 50%;
        padding: 2rem 5rem;

        .news-title{
            font-size: 1.3rem;
            color: #000;
            font-weight: 550;
        }
        .news-nav{
            margin: 1rem 0;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}
::v-deep .el-pagination{
    text-align: right;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #00146E;
}
::v-deep .el-pagination.is-background .el-pager li{
    background-color: #fff;
}
::v-deep .el-pagination.is-background .btn-prev{
    display: none;
}
::v-deep .el-pagination.is-background .btn-next{
    display: none;
}
</style>